export default {
      id: "youtube-usage",
      viewBox: "0 0 30 22",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#youtube",
      toString: function () {
        return this.url;
      }
    }